document.documentElement.classList.add('js');

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  const filter = event.target.closest('[data-gallery-filter]');
  if (filter) {
    const value = filter.dataset.galleryFilter;
    document.querySelectorAll('[data-gallery-filter]').forEach((btn) => btn.classList.toggle('is-active', btn === filter));
    document.querySelectorAll('[data-gallery-item]').forEach((item) => {
      item.hidden = value !== 'all' && item.dataset.galleryCategory !== value;
    });
  }
});
